export default {"src":"/login-app/[GIT_HASH]/_next/static/media/priority_7.af98ad31.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};